module.exports = __webpack_public_path__ + "img/wurlitzer_small_diamond.0e9e9d9f.png";